import React from "react";

export const wrapRootElement = ({ element }) => (
  <>
     <script
      key="osano"
      src={process.env.GATSBY_OSANO_SCRIPT_URL}
      async
    />
    {element}
  </>
);